import { PRIORITIES } from "../lib/helpers";

const DAY_MS = 86400000;
const toDate = (s) => new Date(s.slice(0, 10) + "T00:00:00");

export const TimelineView = ({ board, tasks, onOpen }) => {
  const dated = tasks.filter((t) => t.due_date || t.start_date);
  const undated = tasks.filter((t) => !t.due_date && !t.start_date);

  if (dated.length === 0) {
    return <div className="p-8 text-zinc-500" data-testid="timeline-view">No hay tareas con fechas. Añade fecha de inicio o vencimiento para verlas en el cronograma.</div>;
  }

  const starts = dated.map((t) => toDate(t.start_date || t.due_date).getTime());
  const ends = dated.map((t) => toDate(t.due_date || t.start_date).getTime());
  const min = Math.min(...starts) - 2 * DAY_MS;
  const max = Math.max(...ends) + 3 * DAY_MS;
  const total = max - min;
  const pct = (ms) => ((ms - min) / total) * 100;
  const todayPct = pct(Date.now());

  const ticks = [];
  for (let t = min; t <= max; t += 7 * DAY_MS) ticks.push(t);

  const colColor = (status) => board.columns.find((c) => c.id === status)?.color || "#71717A";

  return (
    <div className="p-4 sm:p-6 lg:p-8 h-full overflow-y-auto" data-testid="timeline-view">
      <div className="relative border border-white/5 rounded-xl bg-[#0E0E10] overflow-hidden">
        <div className="relative h-8 border-b border-white/5">
          {ticks.map((t) => (
            <span key={t} className="absolute top-1/2 -translate-y-1/2 text-[10px] text-zinc-600 pl-1 border-l border-white/5 h-full flex items-center" style={{ left: `${pct(t)}%` }}>
              {new Date(t).toLocaleDateString("es", { day: "numeric", month: "short" })}
            </span>
          ))}
        </div>
        <div className="relative py-2">
          {todayPct >= 0 && todayPct <= 100 && (
            <div className="absolute inset-y-0 w-px bg-primary z-10" style={{ left: `${todayPct}%` }} title="Hoy" />
          )}
          {ticks.map((t) => <div key={t} className="absolute inset-y-0 w-px bg-white/[0.03]" style={{ left: `${pct(t)}%` }} />)}
          {dated.sort((a, b) => (a.start_date || a.due_date).localeCompare(b.start_date || b.due_date)).map((t) => {
            const s = toDate(t.start_date || t.due_date).getTime();
            const e = toDate(t.due_date || t.start_date).getTime() + DAY_MS;
            const left = pct(s), width = Math.max(1.5, pct(e) - left);
            const pr = PRIORITIES[t.priority] || PRIORITIES.medium;
            return (
              <div key={t.id} className="relative h-9 group">
                <button onClick={() => onOpen(t)} data-testid={`timeline-bar-${t.id}`}
                  className="absolute top-1 h-7 rounded-lg flex items-center gap-1.5 px-2 text-xs font-medium truncate hover:brightness-125 transition-all"
                  style={{ left: `${left}%`, width: `${width}%`, background: `${colColor(t.status)}33`, border: `1px solid ${colColor(t.status)}66` }}>
                  <span className="h-1.5 w-1.5 rounded-full shrink-0" style={{ background: pr.color }} />
                  <span className="truncate">{t.title}</span>
                </button>
              </div>
            );
          })}
        </div>
      </div>
      {undated.length > 0 && (
        <div className="mt-5">
          <p className="text-xs uppercase tracking-wider font-semibold text-zinc-500 mb-2">Sin fechas ({undated.length})</p>
          <div className="flex flex-wrap gap-2">
            {undated.map((t) => (
              <button key={t.id} onClick={() => onOpen(t)} className="text-xs bg-[#1C1C1F] border border-white/10 rounded-full px-3 py-1.5 hover:border-white/25">{t.title}</button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
